<template>
  <div>
    <v-form v-model="formValid" lazy-validation ref="form">
      <v-layout wrap align-center>
        <v-flex xs12 sm6 offset-sm3>
          <v-btn
            flat
            icon
            :to="{
              name: 'list-pages-list',
              params: { listPage: $route.params.listPage }
            }"
            exact
          >
            <v-icon v-text="fa('angle-left')"></v-icon>
          </v-btn>
          <v-card v-if="item">
            <v-img v-if="item.image" :src="item.image" aspect-ratio="2.75" />

            <v-card-title primary-title>
              <div class="flex">
                <Storage
                  v-model="item.image"
                  :type="
                    `listPages/${$route.params.listPage}/items/${
                      $route.params.id
                    }`
                  "
                />
                <v-text-field
                  label="Title"
                  v-model="item.title"
                  :rules="[formRules.required]"
                />
                <v-text-field
                  label="Subtitle"
                  v-model="item.subTitle"
                  :rules="[formRules.required]"
                />

                <v-flex xs12>
                  <v-subheader>Metadata</v-subheader>
                </v-flex>
                <v-flex xs12>
                  <v-layout wrap v-for="(key, i) of metadataKeys" :key="i">
                    <v-flex xs12 sm2>
                      <v-text-field
                        label="Key"
                        v-model="metadataKeys[i]"
                        :rules="[formRules.required]"
                      />
                    </v-flex>
                    <v-flex xs12 sm9>
                      <v-text-field
                        label="Value"
                        v-model="metadataValues[i]"
                        :rules="[formRules.required]"
                      />
                    </v-flex>
                    <v-flex xs12 sm1>
                      <v-btn
                        @click="
                          metadataKeys.splice(i, 1);
                          metadataValues.splice(i, 1);
                        "
                        icon
                      >
                        <v-icon v-text="fa('trash-alt')"></v-icon>
                      </v-btn>
                    </v-flex>
                  </v-layout>

                  <v-btn
                    block
                    @click="
                      metadataKeys.push('');
                      metadataValues.push('');
                    "
                  >
                    <v-icon v-text="fa('plus')"></v-icon> add
                  </v-btn>
                </v-flex>
              </div>
            </v-card-title>
          </v-card>
        </v-flex>
        <v-flex xs12 sm6 offset-sm3>
          <v-btn block color="primary" @click="save" :disabled="loading"
            >Save</v-btn
          >
        </v-flex>
      </v-layout>
    </v-form>
  </div>
</template>

<script>
import { db } from "../../plugins/firebase";
import { eventHub } from "../../config/constants";
import Storage from "../../components/Storage";

export default {
  name: "ListPageItem",
  components: {
    Storage
  },
  data: () => ({
    formValid: true,
    loading: false,
    item: null,
    metadataKeys: [],
    metadataValues: []
  }),
  async created() {
    const { listPage, id } = this.$route.params;
    const listPageDoc = db.collection("listPages").doc(listPage);
    this.$bind("item", listPageDoc.collection("items").doc(String(id)));
  },
  watch: {
    item(item) {
      this.metadataKeys = Object.keys(item.data);
      this.metadataValues = Object.values(item.data);
    }
  },
  methods: {
    async save() {
      if (!this.$refs.form.validate()) {
        return;
      }
      this.loading = true;
      const item = this.item;
      const previousData = this.item.data;
      try {
        item.data = this.metadataKeys.reduce((metadata, key, i) => {
          metadata[key] = this.metadataValues[i];
          return metadata;
        }, {});
        await db.runTransaction(async t =>
          t.set(this.$firestoreRefs.item, item)
        );
        eventHub.$emit("message", "green");
      } catch (error) {
        item.data = previousData;
        eventHub.$emit("message", "red", error.code);
      }
      this.loading = false;
    }
  }
};
</script>

<style></style>
